'use strict';

var _analytics = require('./analytics.js');

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _analytics2.default;


// WEBPACK FOOTER //
// ../~/@jg/koala-front-end-analytics/lib/index.js